module.exports = __webpack_public_path__ + "static/img/wzry-enterpriseCulture2.bf38e26f.png";